import { StopProcessStepRecordingRequestSchema, StopProcessStepRecordingResponseSchema } from './stop-process-step-recording.schema';
/**
 * Stop Process Step Recording Endpoint Contract
 * Transitions a recording from in_progress → pending_finalization.
 */ export const stopProcessStepRecordingContract = {
    method: 'POST',
    path: '/api/v2/process-step-recording/:id/stop-recording',
    description: 'Stop a process step recording and open the review state. AI summary runs async.',
    requestSchema: StopProcessStepRecordingRequestSchema,
    responseSchema: StopProcessStepRecordingResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Step recording not properly defined',
            401: 'Unauthorized',
            404: 'Step recording not found'
        }
    }
};

//# sourceMappingURL=stop-process-step-recording.contract.js.map